import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import printSettingsService from '../services/printSettingsService';
import ProtectedSection from '../components/ProtectedSection';

export default function PrintSettingsPage() {
  const [form, setForm] = useState({
    businessName: '',
    addressLine: '',
    phoneLine: '',
    cityLine: '',
    headerText: '',
    footerText: '',
    receiptNote: '',
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const load = async () => {
    try {
      setLoading(true);
      setErr('');
      const data = await printSettingsService.get();
      setForm({
        businessName: data.businessName || '',
        addressLine: data.addressLine || '',
        phoneLine: data.phoneLine || '',
        cityLine: data.cityLine || '',
        headerText: data.headerText || '',
        footerText: data.footerText || '',
        receiptNote: data.receiptNote || '',
      });
    } catch (e) {
      console.error(e);
      setErr(
        e?.response?.data?.message ||
        'Erreur lors du chargement des paramètres impression.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setMsg('');
      setErr('');
      await printSettingsService.update(form);
      setMsg('Paramètres impression enregistrés avec succès.');
    } catch (e2) {
      console.error(e2);
      setErr(
        e2?.response?.data?.message ||
        'Erreur lors de la sauvegarde des paramètres impression.'
      );
    }
  };

  return (
    <Container fluid className="mt-4">
      <h3 className="fw-semibold mb-3">Paramètres imprimante et impression</h3>

      {err && <Alert variant="danger">{err}</Alert>}
      {msg && <Alert variant="success">{msg}</Alert>}

      <Card className="shadow-sm">
        <Card.Body>
          {loading ? (
            <div>Chargement…</div>
          ) : (
            <Form onSubmit={onSubmit}>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nom de l’entreprise</Form.Label>
                    <Form.Control
                      value={form.businessName}
                      onChange={(e) => onChange('businessName', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Ville / ligne complémentaire</Form.Label>
                    <Form.Control
                      value={form.cityLine}
                      onChange={(e) => onChange('cityLine', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Adresse</Form.Label>
                    <Form.Control
                      value={form.addressLine}
                      onChange={(e) => onChange('addressLine', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Téléphone</Form.Label>
                    <Form.Control
                      value={form.phoneLine}
                      onChange={(e) => onChange('phoneLine', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Texte d’entête</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={form.headerText}
                      onChange={(e) => onChange('headerText', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Note de reçu</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={form.receiptNote}
                      onChange={(e) => onChange('receiptNote', e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Texte de pied de page</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={form.footerText}
                      onChange={(e) => onChange('footerText', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="mt-4">
                <ProtectedSection code="PRINT_SETTINGS_UPDATE">
                  <Button type="submit" variant="primary">
                    Enregistrer
                  </Button>
                </ProtectedSection>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}